import React from 'react';
import { Input, Select, Icon, Row, Col } from 'antd';

import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>
                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={6}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.nombre}
                            onChange={e => this.props.onChange("nombre", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por nombre"
                            autoComplete="off"
                        />
                    </Col>

                    {this.props.filter.activeKey == "1" ?
                        <Col className="gutter-row" sm={24} md={12} lg={8} xl={6}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.idTipoCampo ?
                                        { key: this.props.filter.idTipoCampo } : undefined
                                }
                                placeholder={<SelectPlaceHolder label="Filtrar por tipo campo" />}
                                onChange={(option) => this.props.onChange("idTipoCampo", option.key)}
                                optionFilterProp="children"
                            >
                                {this.props.tipoCampos.map(item => ( //STATE DATA
                                    <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                                ))}
                            </Select>
                        </Col>
                        : null}


                    <Col className="gutter-row" sm={24} md={12} lg={8} xl={6}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.estado ?
                                    { key: this.props.filter.estado } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por estado" />}
                            onChange={(option) => this.props.onChange("estado", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.estados.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Filters;